import { Eleve } from '@teetsh/app/src/types/eleves';
import { allGroupValue } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/constants';

export function findElevesForGroups(eleves: Eleve[], groups: string[]) {
  if (groups.includes(allGroupValue) || groups.length === 0) {
    return eleves;
  }

  return eleves.filter(
    e =>
      e.groupNames?.some(g => groups.includes(g)) ||
      e.classroomNames?.some(g => groups.includes(g)),
  );
}
